module.exports = __webpack_public_path__ + "img/zoom-in.0cf1a3fb.svg";